import { render, staticRenderFns } from "./AudkenniLogIn.vue?vue&type=template&id=afdb3e56&"
import script from "./AudkenniLogIn.vue?vue&type=script&lang=js&"
export * from "./AudkenniLogIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports